import styled from "styled-components";

import { APPLICATION_SPACING } from "../../styling/spacing";
import { LayoutContainer } from "../layout/LayoutContainer";

export const Content = styled(LayoutContainer)`
  padding: ${APPLICATION_SPACING(3)};
`;
